import React from 'react';

export const CloseEmptyIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" focusable="false" aria-hidden="true">
    <path
      d="M24 9.4 22.6 8 16 14.6 9.4 8 8 9.4l6.6 6.6L8 22.6 9.4 24l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L24 9.4z"
      fill="currentColor"
    />
  </svg>
);
